module.exports = __webpack_public_path__ + "img/JLK_Logo.a530bbf0.png";